import React from 'react'

const About = () => {
    return (
        <div className="white">
            <h4 className="flaw-text" style={{margin:'20px'}}>Meme Generator App v1.0.0</h4>
        </div>
    )
}

export default About
